<template>
    <div class="contents">
        <div v-if="hasMessages" @mouseenter="delayedMarkUnreadAsRead">
            <transition-group
                name="slide-fade"
                tag="div"
                enter-active-class="transition duration-300 ease-out transform"
                enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition duration-100 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <notification-message v-for="message in messages" :key="message.id" :message="message" />
            </transition-group>
        </div>
        <div v-else>
            <IllustratedMessage>
                <template #image>
                    <icon icon="hero/outline/bell-slash" class="w-12 h-12"></icon>
                </template>
                <template #title>{{ lang('notifications::notifications.no_entries') }} </template>
                {{ lang('notifications::notifications.no_entries_description') }}
            </IllustratedMessage>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useNotificationArea } from '@src/Notifications/Pages/composables/useNotificationArea';
import NotificationMessage from '@src/Notifications/Pages/NotificationMessage.vue';

const { hasMessages, messages, delayedMarkUnreadAsRead } = useNotificationArea();
</script>
